import { ICategoryResponse } from '../../api/getCategories/types';

export const getCategoryItemCount = (category: ICategoryResponse, categories: ICategoryResponse[]): number => {
  const subCategories = categories.filter((cat) => category.section_id === cat.parent_section_id);
  let totalSubItems = 0;

  subCategories.forEach((subCategory) => {
    totalSubItems += getCategoryItemCount(subCategory, categories);
  });
  return category.items.length + totalSubItems;
};
